import { MutationTree } from "vuex";
import PeopleSearchWidgetState from "@/apps/PeopleSearchWidget/models/people-search-widget-state";
import { Config } from "@/apps/PeopleSearchWidget/models/config-viewmodel";
import { VUwebPeopleSearchService } from "@/shared/services/azure-search-service";
import { Person } from "@/apps/PeopleSearchWidget/models/person-viewmodel";

export default <MutationTree<PeopleSearchWidgetState>>{
    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setInnerLoading(state, innerLoading: boolean) {
        state.innerLoading = innerLoading;
    },

    setError(state, error: string) {
        state.error = error;
    },

    setAzureService(state) {
        state.azureService = new VUwebPeopleSearchService(state.config.index, state.config.endpoint);
    },

    setSearchQuery(state, query: string) {
        state.searchQuery = query;
    },

    setTotalResults(state, count: number) {
        state.totalResults = count;
    },

    setResults(state, results: Person[]) {
        state.results = results;
    },

    setCurrentPage(state) {
        state.currentPage++;
    },

    resetCurrentPage(state) {
        state.currentPage = 0;
    }
}
